export default __webpack_public_path__ + "static/media/Group 1171276208 (3).8f391c99.svg";